<div class="submenu-container">
  <button class="back-btn" (click)="goTo(submenuService.backPath)">
    <img src="/assets/img/icons/arrow-left-bold-black.svg" alt="arrow-left-bold-black icon"/>
    {{ submenuService.backText }}
  </button>

  <div class="section-title">
    <p *ngIf="isPrivateUrl">{{ serviceTabs.privateService?.name | uppercase }}</p>
    <p *ngIf="!isPrivateUrl">{{ serviceTabs.publicService?.name | uppercase }}</p>
  </div>

  <!-- Public Tabs -->
  <ul *ngIf="!isPrivateUrl && existPublicTabs" class="list-unstyled">
    <li *ngFor="let tab of serviceTabs.publicService.tabs" class="menu-item" routerLinkActive="menu-item-active">
      <a class="menu-item-link" [routerLink]="[tab.path]" *ngIf="!tab.forceRedirect">{{ tab.title }}</a>
      <a class="menu-item-link" (click)="goTo(tab.path)" *ngIf="tab.forceRedirect">{{ tab.title }}</a>
    </li>
  </ul>
  <!-- Private Tabs -->
  <ul *ngIf="isPrivateUrl && existPrivateTabs" class="list-unstyled">
    <li *ngFor="let tab of serviceTabs.privateService.tabs" class="menu-item" routerLinkActive="menu-item-active">
      <a class="menu-item-link" [routerLink]="[tab.path]" *ngIf="!tab.forceRedirect">{{ tab.title }}</a>
      <a class="menu-item-link" (click)="goTo(tab.path)" *ngIf="tab.forceRedirect">{{ tab.title }}</a>
    </li>
  </ul>
</div>
